// @ts-nocheck
import { GridContainerProps } from "@insite/mobius/GridContainer";
import { GridItemProps } from "@insite/mobius/GridItem";
import { pxToRemArray } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { gridGapStyles } from "@toolkit/Themes/common/mixins";
import { css } from "styled-components";

export interface RequirementsGridProps {
    container: GridContainerProps;
    formColumn: GridItemProps;
    requirementsDesktopColumn: GridItemProps;
    requirementsMobileColumn: GridItemProps;
}

export const requirementsGridProps: RequirementsGridProps = {
    container: {
        gap: 0,
        css: css`
            ${x => gridGapStyles(pxToRemArray([50]), [x.theme.design.typography.spacing.larger])}
        `,
    },
    formColumn: {
        width: [12, 12, 6, 6, 6],
        css: css`
            display: block;
        `,
    },
    requirementsDesktopColumn: {
        width: [0, 0, 6, 6, 6],
        css: css`
            display: block;
        `,
    },
    requirementsMobileColumn: {
        width: [12, 12, 0, 0, 0],
        css: css`
            display: block;
        `,
    },
};
